export interface GeneralMonitoredRule {
  targetActivityType: string;
  ruleTriggerDate: string;
  ruleTriggers: number;
  ruleId: number;
  recommendationId: string;
  recommendations: number;
  behavioralProfiles: number;
  restrictedBehavioralProfiles: number;
  incidentsInvolvingRuleTriggers?: IncidentData[];
  companyId: string;
  phasrUsable: boolean;
}

export interface IncidentData {
  incidentId: string,
  incidentNumber: number
}
export const INCIDENT_DISPLAY_LIMIT = 3;

export const BEHAVIORAL_PROFILE_DISPLAY_LIMIT = 9999;
